import { Injectable, NgZone } from '@angular/core';

import { Store } from '@ngrx/store';

import { HubConnection } from '@microsoft/signalr';

import { LocationsHubService } from '@era/core';
import { PairingCompletedEvent } from '@era/locations-sdk';
import { PairingStoreActions, PairingStoreStates } from '../sub-features/device-pairing/pairing-store';

@Injectable()
export class PairingSignalR {
  private readonly hubConnection: HubConnection;

  constructor(
    private readonly zone: NgZone,
    locationsHubService: LocationsHubService,
    private readonly store: Store<PairingStoreStates.State>
  ) {
    this.hubConnection = locationsHubService.hubConnection;
    this.initialize();
  }

  private initialize() {
    this.hubConnection.on('onPairingCompleted', (pairingCompletedEvent: PairingCompletedEvent) => {
      this.zone.run(() => {
        this.store.dispatch(
          PairingStoreActions.PairingSignalRActions.enrollmentCompleted({
            challenge: pairingCompletedEvent.pairingRequest.challenge,
          })
        );
      });
    });
  }
}
